import DashboardLayout from "@/pages/layouts/DashboardLayout";

let panelRoutes = {
  path: '/panels',
  component: DashboardLayout,
  redirect: '/panels/list',
  children: [
    {
      path: 'list',
      name: 'Panels List',
      component: () => import(/* webpackChunkName: "panels" */  '@/pages/panels/PanelList'),
      meta: {
        permissionsCodes: ['panels/index'],
      }
    },
    {
      path: 'create',
      name: 'Add Panel',
      component: () => import(/* webpackChunkName: "panels" */  '@/pages/panels/PanelForm'),
      meta: {
        permissionsCodes: ['panels/create'],
      }
    },
    {
      path: 'edit/:id',
      name: 'Edit Panel',
      component: () => import(/* webpackChunkName: "panels" */  '@/pages/panels/PanelForm'),
      meta: {
        permissionsCodes: ['panels/update'],
      }
    }
  ]
}

export default panelRoutes;
